/**
 * The two places this app has to know what it is running on.
 *
 * Both are genuine capability gaps rather than styling preferences — Web Push
 * is absent on iOS until the app is installed, and WebKit will not render a PDF
 * inside a page there at all — so they are answered once, here, rather than
 * sniffed at each call site.
 */

export function isIos(): boolean {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ reports itself as a Mac; the touch point count gives it away.
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/**
 * Whether a PDF will render inside the page.
 *
 * iOS is the exception, and it is absolute: an `<iframe>` or `<object>` pointed
 * at a PDF is a blank white rectangle on iPhone and iPad, with no error and no
 * fallback content shown. Nothing about the file or the CSP changes that, so a
 * viewer that means to show a PDF has to ask first and offer the document
 * another way when the answer is no.
 */
export function canRenderPdfInline(): boolean {
  return !isIos();
}
